import { makeStyles } from 'tss-react/mui';

const useStylesTableRow: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  tableRowButton: {
    '& > td, & > th': {
      cursor: 'pointer !important',
      '& > *': {
        cursor: 'pointer !important',
      },
    },
  },
  tableRowSelected: {
    backgroundColor: `${theme.palette.secondary.light} !important`,
    '&:hover': {
      backgroundColor: `${theme.palette.secondary.light} !important`,
    },
  },
  tableRowCompleted: {
    backgroundColor: `${theme.palette.success.light} !important`,
  },
  tableRowAlignTop: {
    '& > td': {
      verticalAlign: 'top',
    },
  },
}));

export default useStylesTableRow;
